/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from "react";
import makeRequest from "../api/makeRequest";

const fetchFromURL = async (url) => {
  if (typeof url !== "string") {
    throw new Error(`The url value must be a string`);
  }

  let json;

  try {
    const response = await makeRequest.get(url, { cache: "force-cache" });
    json = response?.data;
  } catch (err) {
    console.error(
      `An error occurred while trying to load the Lottie file from URL: ${err.message}`,
    );
    return null; // Return null instead of throwing an error
  }

  return json;
};

const cache = {};

const useLottie = (url) => {
  const [jsonData, setJsonData] = useState(null);

  useEffect(() => {
    if (cache[url]) {
      setJsonData(cache[url]);
    } else {
      fetchFromURL(url).then((data) => {
        if (data !== null) {
          // Check if data is null before caching and setting state
          cache[url] = data;
          setJsonData(data);
        }
      });
    }
  }, [url]);

  return jsonData;
};

export { useLottie };
